import type {
  MeResponse,
} from '../../types/me'

import {
  AdminIcon,
} from './AdminIcon'

type AdminHeaderProps = {
  me: MeResponse
  sidebarCollapsed: boolean
  onToggleSidebar: () => void
  onOpenMobileSidebar: () => void
}

export function AdminHeader({
  me,
  sidebarCollapsed,
  onToggleSidebar,
  onOpenMobileSidebar,
}: AdminHeaderProps) {
  const avatar =
    me.avatar?.trim()
      ? me.avatar
      : null

  return (
    <header className="admin-header">
      <div className="admin-header__left">
        <button
          type="button"
          className="admin-header__menu admin-header__menu--desktop"
          onClick={onToggleSidebar}
          aria-label={
            sidebarCollapsed
              ? 'Развернуть меню'
              : 'Свернуть меню'
          }
        >
          <AdminIcon
            name="menu"
            size={21}
          />
        </button>

        <button
          type="button"
          className="admin-header__menu admin-header__menu--mobile"
          onClick={onOpenMobileSidebar}
          aria-label="Открыть меню"
        >
          <AdminIcon
            name="menu"
            size={21}
          />
        </button>

        <div className="admin-header__context">
          <span className="admin-header__eyebrow">
            Kraken Academy
          </span>

          <span className="admin-header__title">
            Admin Core
          </span>
        </div>
      </div>

      <div className="admin-header__right">
        <a
          href="/"
          className="admin-header__academy"
        >
          <AdminIcon
            name="home"
            size={18}
          />

          <span>
            Академия
          </span>
        </a>

        <div className="admin-header__separator" />

        <div className="admin-header__user">
          <div className="admin-header__user-text">
            <strong>
              {me.name}
            </strong>

            <span>
              Administrator
            </span>
          </div>

          <div className="admin-header__avatar">
            {avatar ? (
              <img
                src={avatar}
                alt=""
              />
            ) : (
              <span>
                {me.name
                  .slice(0, 1)
                  .toUpperCase()}
              </span>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}
